import {removeCustomerOfferNote} from "@project/sdk/sales";
import {RemoveCustomerOfferNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../../../customerOffer-keys";

export function removeCustomerOfferNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.removeCustomerOfferNote,
    mutationFn: async (noteId: number) =>
      RemoveCustomerOfferNoteResponse.parse(await removeCustomerOfferNote(id, noteId)),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
